import React, { useState } from 'react';
import Header from '../Header';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { Spinner } from 'react-bootstrap'; // Add this line

const Lead = () => {
  const id = localStorage.getItem('userId');
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const [lead, setLead] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    whatsapp: '',
    address: '',
    source: '',
    leadBy: '',
    status: 'open',
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setLead({
      ...lead,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    const leadData = {
      company: lead.company,
      name: lead.name,
      email: lead.email,
      phone: lead.phone,
      whatsapp: lead.whatsapp,
      address: lead.address,
      source: lead.source,
      leadBy: id,
      status: lead.status,
    };

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(leadData),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || 'Submission failed');

      if (data.status === 'success') {
        setSuccessMessage(data.message);
        setLead({
          company: '',
          name: '',
          email: '',
          phone: '',
          whatsapp: '',
          address: '',
          source: '',
          leadBy: '',
          status: 'open',
        });
      } else if (data.status === 'error') {
        setErrorMessage(data.message);
      }
    } catch (error) {
      console.error('Error during submission:', error);
      setErrorMessage('There was an error submitting the lead. Please try again.');
    } finally {
      setLoading(false); // Stop loading
      setTimeout(() => {
        setSuccessMessage('');
        setErrorMessage('');
      }, 5000);
    }
  };

  return (
    <>
      <Header />

      <div className="container mt-5">
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        <div className="card shadow">
          <div className="card-header">
            <h2>
              Add Leads &nbsp;
              <button className="btn btn-primary" onClick={() => navigate('/Leadlist')}>Lead List</button>
            </h2>
          </div>

          <div className="card-body">
            {loading ? (
              <div className="text-center my-5">
                <Spinner animation="border" role="status" />
                <div className="mt-3">Submitting Lead...</div>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="name" className="form-label">Company / Bussiness Name</label>
                    <input type="text" className="form-control" id="company" name="company" value={lead.company} onChange={handleChange} required />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text" className="form-control" id="name" name="name" value={lead.name} onChange={handleChange} required />
                  </div>

                 
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" className="form-control" id="email" name="email" value={lead.email} onChange={handleChange} required />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="phone" className="form-label">Phone</label>
                    <input type="tel" className="form-control" id="phone" name="phone" value={lead.phone} onChange={handleChange} required />
                  </div>

                  
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="whatsapp" className="form-label">WhatsApp</label>
                    <input type="tel" className="form-control" id="whatsapp" name="whatsapp" value={lead.whatsapp} onChange={handleChange} />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="address" className="form-label">Address</label>
                    <input type="text" className="form-control" id="address" name="address" value={lead.address} onChange={handleChange} />
                  </div>

                  
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="source" className="form-label">Source</label>
                    <input type="text" className="form-control" id="source" name="source" value={lead.source} onChange={handleChange} required />
                  </div>

                  <div className="col-md-6 mb-3 d-none">
                    <label htmlFor="leadBy" className="form-label">Lead By</label>
                    <input type="text" className="form-control" id="leadBy" name="leadBy" value={id} readOnly />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="status" className="form-label">Status</label>
                    <select className="form-select" id="status" name="status" value={lead.status} onChange={handleChange} readOnly required>
                      <option value="open">Open</option>
                    </select>
                  </div>
                </div>

                <center>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </center>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Lead;
